<template>
	<div class="custom-global-input" :class="{ 'custom-global-input--required': required, 'custom-global-input--success': success }">
		<v-text-field ref="inputRef" flat v-bind="$attrs" density="comfortable" variant="solo">
			<template v-if="appendInner" #append-inner>
				<template v-if="appendAction">
					<div class="custom-global-input__center" @click="emit('makeAction')">
						<GlobalIcon :name="appendInner" :height="20"></GlobalIcon>
					</div>
				</template>
				<template v-else>
					<GlobalIcon :name="appendInner" :height="20"></GlobalIcon>
				</template>
			</template>
			<template v-else-if="success" #append-inner>
				<div class="custom-global-input__success">
					<GlobalIcon name="tick-circle" :height="18"></GlobalIcon>
				</div>
			</template>
			<template v-if="prependInner" #prepend-inner> <GlobalIcon :name="prependInner" :height="18" /> </template>
		</v-text-field>
	</div>
</template>

<script setup lang="ts">
interface InputProps {
	isEmailTaken?: boolean
	appendInner?: string
	required?: boolean
	prependInner?: string
	success?: boolean
	appendAction?: boolean
}

const inputRef = ref()
// const localePath = useLocalePath()

watch(
	() => inputRef.value,
	(newValue) => {
		if (inputRef.value) emit('update:ref', newValue)
	},
	{ deep: true },
)

defineProps<InputProps>()

const emit = defineEmits<{
	(e: 'update:ref', value: Ref): void
	(e: 'makeAction'): void
}>()
</script>

<style lang="scss" src="./Primary.scss"></style>
